import type { Cfg } from './types';

export type DirectoryEndpoint = 'markers' | 'search' | 'suggestions';

const ENDPOINT_PATHS: Record<DirectoryEndpoint, string> = {
    markers: '/member-directory/markers',
    search: '/member-directory/search',
    suggestions: '/member-directory/suggestions',
};

function buildQuery(params: Record<string, string | string[]> = {}): string {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (Array.isArray(v)) {
            v.forEach(item => sp.append(k + '[]', item));
        } else if (v) {
            sp.append(k, v);
        }
    });
    return sp.toString();
}

export async function directoryGet<T = unknown>(
    cfg: Cfg,
    endpoint: DirectoryEndpoint,
    params: Record<string, string | string[]> = {},
): Promise<T> {
    const baseUrl = String(cfg.rest_base_url || '/wp-json/gas/v1').replace(/\/+$/, '');
    const query = buildQuery(params);
    const headers: Record<string, string> = { Accept: 'application/json' };
    if (cfg.rest_nonce) {
        headers['X-WP-Nonce'] = cfg.rest_nonce;
    }

    const res = await fetch(baseUrl + ENDPOINT_PATHS[endpoint] + (query ? '?' + query : ''), {
        method: 'GET',
        credentials: 'same-origin',
        headers,
    });
    const json = (await res.json()) as { data?: T; message?: string };
    if (!res.ok) {
        throw new Error(json.message || '');
    }
    return (json.data ?? {}) as T;
}
